import React from "react";
import Image from "next/image";

const BrowseByUseCase: React.FC<{ handleQuery: any; tagsData: any }> = ({ handleQuery, tagsData }) => {
    const getImageName = (name: string) => {
        if (name === "Discovery") {
            return "signup";
        }
        return name.toLowerCase().replace(" / ", " ").split(" ").join("-");
    };

    return (
        <div className={"browseByUseCase"}>
            <h2 style={{ fontSize: "30px" }}>Browse Bot Templates by Usecase</h2>
            <div className="wrapper items-baseline">
                {tagsData.map((each: string) => (
                    <div className="each-tag" onClick={() => handleQuery(each)} key={each}>
                        <div className="icon">
                            <Image
                                src={`https://assets.gallabox.com/gb-home/bot-templates/use-cases-icons/${getImageName(each)}-icon.svg`}
                                alt={each}
                                quality={80}
                                layout="fixed"
                                width={40}
                                height={30}
                            />
                        </div>
                        <p>{each}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BrowseByUseCase;
